import { render, staticRenderFns } from "./FilterGeoNovation.vue?vue&type=template&id=b84069c0&"
import script from "./FilterGeoNovation.vue?vue&type=script&lang=js&"
export * from "./FilterGeoNovation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports